'use client';
import classNames from 'classnames/bind';
import React from 'react';
import AnchorButton from '../../common/AnchorButton.mjs';
import DimmedLayer from '../../common/DimmedLayer.mjs';
import IcClose from '../../icons/IcClose.mjs';
import { MODAL_CATEGORY, MODAL_ID } from '../../../constants/modal.mjs';
import { useModalStore, useBottomModalNotice, modalInternal } from '../../../contexts/ModalContext.mjs';
import styles from './BottomModalNoticeWrapper.module.scss.mjs';

const cx = classNames.bind(styles);
function BottomModalCloseButton(_ref) {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB808\uC774\uC5B4 \uB2EB\uAE30"));
}
function BottomModalNoticeWrapper(_ref2) {
  let {
    isPreRender,
    hasBottomNavigationBar = true,
    underlineButton,
    children,
    onClickDimmedLayer,
    onClickCloseButton
  } = _ref2;
  const {
    modals
  } = useModalStore();
  const {
    close
  } = useBottomModalNotice();
  const bottomModalNotice = modals.find(m => m.category === MODAL_CATEGORY.BOTTOM_NOTICE);
  const {
    isOpen = false,
    isShow = false,
    toBeDestroyed = false
  } = bottomModalNotice ?? {};
  const handleTransitionEnd = () => toBeDestroyed && modalInternal.destroy(MODAL_CATEGORY.BOTTOM_NOTICE);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      hide: isPreRender
    }),
    onTransitionEnd: handleTransitionEnd,
    ...(isOpen ? {
      tabIndex: 0
    } : {})
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('layer', {
      show: isShow
    }, {
      'not-navi': !hasBottomNavigationBar
    }),
    id: MODAL_ID.BOTTOM_MODAL_NOTICE
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('inner')
  }, children, underlineButton ? ( /*#__PURE__*/React.createElement("div", {
    className: cx('area-button')
  }, /*#__PURE__*/React.createElement(AnchorButton, {
    ...underlineButton,
    className: cx('button-text')
  }, underlineButton.text))) : null), /*#__PURE__*/React.createElement(BottomModalCloseButton, {
    onClick: onClickCloseButton ?? close
  }))), /*#__PURE__*/React.createElement(DimmedLayer, {
    isShow: isShow,
    onClick: onClickDimmedLayer ?? close
  }));
}

export { BottomModalNoticeWrapper as default };
